<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/NIu5P/tc-custom/9781540260772.jpg?1731986108909" alt="This image is the cover for the book Holocaust Refugees in Oswego, American Heritage"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Holocaust Refugees in Oswego, American Heritage
      </h1>
      <p class="bookDescription body article font2">
        <p>America's Only Shelter Established for Holocaust Refugees/ During the height of the second World War, at the order of President Roosevelt, Fort Ontario in Oswego, New York housed 982 refugees, rescued from the horrors of the Holocaust. The community of Oswego answered the call of service and opened its arms to the survivors. Oswegonian and WWII veteran Joseph Spereno's connection with refugee Jake Sylber helped launch his tailoring business that was a fixture in the city for more than 20 years. Then high school Principal Ralph Faust was among local educators who fought to allow the refugee children into Oswego schools, forging connections with those young people who went on to distinguished careers. Local Boy Scout leader Harold Clark created a troop for refugee children to share in the American experience of scouting.Author Ann Callaghan Allen presents the harrowing narrative of how Oswego gave shelter to hundreds of Holocaust survivors.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ann Callaghan Allen
      </h2>
      
      <p class="authorDescription body article">After a professional career as a news reporter, editor and college professor Ann Callaghan Allen retired from teaching in the Department of Communication and Film Studies at Le Moyne College in Syracuse, New York. She returned to her hometown of Oswego, New York, and wrote her first book, The Madame's Business , chronicling the life of Malvina Guimaraes, an early entrepreneur who challenged the social norms of the day and built a financial empire, only to see it threatened by an unscrupulous husband who had nineteenth-century law and conventional thinking about a woman's place on his side.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The History Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?769ab6b8